import React from 'react'
import NumberFormat from 'react-number-format';
import QuantityButtons from '../components/CompanyComponents/QuantityButtons';
import { useTranslation } from '../hooks/useTranslation';


function ProductDetailsRows({ product, itemsCount, addItemToCart, removeItemFromCart, invalidProductAmount }) {
    const { t } = useTranslation();
    return (
        <div>
            <div role="application"
                aria-roledescription={t("Price")}
                aria-label={`${t("Price")} ${product.productPriceAfterDiscount} ${product.currencyCode ? product.currencyCode.replace("ILS", "₪") : product.currencyCode}`}
                className="d-flex justify-content-between pb-4 border-underline-mobile"
            >
                <span>{t("Price")}</span>
                <NumberFormat
                    value={product.productPriceAfterDiscount}
                    displayType={'text'}
                    thousandSeparator={true}
                    prefix={product.currencyCode ? product.currencyCode.replace("ILS", "₪") : product.currencyCode}
                />
            </div>
            <div className="quantity-btns pb-3 pt-1 border-underline-mobile">
                <span className="quantity">{t("Quantity")}</span>
                <QuantityButtons
                    product={product}
                    itemsCount={itemsCount}
                    addItemToCart={addItemToCart}
                    removeItemFromCart={removeItemFromCart}
                />
            </div>
            {invalidProductAmount && <span role="alert" autoFocus className="text-danger bold d-flex justify-content-end">{t("SelectQuantity")}</span>}
            <div
                role="application"
                aria-roledescription={t("Price")}
                aria-label={`${t("Total")} ${(product.productPriceAfterDiscount * itemsCount) + (product.currencyCode ? product.currencyCode.replace("ILS", "₪") : product.currencyCode)}`}
                className="d-flex justify-content-between total-price pb-3 border-underline-mobile">
                <span>{t("Total")}</span>
                <NumberFormat className="prod-prc"
                    value={(product.productPriceAfterDiscount * itemsCount).toFixed(2)}
                    displayType={'text'}
                    thousandSeparator={true}
                    prefix={product.currencyCode ? product.currencyCode.replace("ILS", "₪") : product.currencyCode}
                />
            </div>
        </div>
    )
}

export default ProductDetailsRows